var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('client-only',[_c('b-link',{attrs:{"href":_vm.getHref()}},[_c('b-icon-envelope-fill'),_vm._v(" "),_c('span',{staticClass:"nav-link-text"},[_vm._v(_vm._s(_vm.getValue()))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }